"use client";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import "./style.css";

interface CardProps {
  authorName: string;
  publishDate: string;
  titleText: string;
  featuredPost?: boolean;
  category_name?: string;
  category_slug?: string;
  category_color?: string;
  sub_category_name?: string;
  sub_category_slug?: string;
  sub_category_color?: string;
  postForSubscriber?: boolean;
  links?: string[];
  imgSrc?: string;

  className?: string;
  style?: React.CSSProperties;
  imgStyle?: React.CSSProperties;
  cardLink?: string;

  compact?: boolean;
  metaClassName?: string;
  authorClassName?: string;
  authorSlugClassName?: string;
  timeClassName?: string;
  titleClassName?: string;
  imageWrapperClassName?: string;
  bodyClassName?: string;
  responsiveimageClassName?: string;
  dotSeparatoClassName?: string;
  authorSlug?: string;
}

const ensureAbsolute = (url?: string) => {
  if (!url || url === "location not found") return "/";
  if (url.startsWith("/") || url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `/${url}`;
};

export default function CommonCard({
  authorName,
  publishDate,
  titleText,
  featuredPost,
  category_name,
  category_slug,
  category_color,
  sub_category_name,
  sub_category_slug,
  sub_category_color,
  postForSubscriber,
  links,
  imgSrc,
  className = "",
  style,
  imgStyle,
  cardLink,
  compact = false,
  metaClassName = "",
  authorClassName = "",
  authorSlugClassName = "",
  timeClassName = "",
  titleClassName = "",
  imageWrapperClassName = "",
  bodyClassName = "",
  responsiveimageClassName = "",
  dotSeparatoClassName = "",
  authorSlug = "",
}: CardProps) {
  console.log(
    "CommonCard props:",
    category_name,
    category_slug,
    sub_category_name,
    sub_category_slug,
  );

  // Convert publishDate string to a Date object
  const formattedDate = publishDate
    ? new Date(publishDate).toLocaleString("en-US", {
      day: "2-digit",
      month: "short", // Feb, Mar, etc.
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true, // for AM/PM
    })
    : "";
  console.log("imgSrc", imgSrc);
  console.log("titleText", titleText);
  return (
    <div
      className={`card border-0 overflow-hidden  card-container ${compact ? "flex-row align-items-center px-0" : ""
        } ${className}`}
      style={{ ...style }}
    >
      {/* Image */}
      <div
        className={`overflow-hidden ${compact ? "shrink-0" : ""
          } ${imageWrapperClassName}`}
      >
        <Link href={ensureAbsolute(cardLink)}>
          <Image
            src={imgSrc || "/image-not-found.png"}
            className={`rounded-2 card-image ${responsiveimageClassName}`}
            alt={`${authorName} ${titleText}`}
            height={2520}
            width={350}
            style={{
              width: "100%",
              // height: "317px",
              height: "auto",
              ...imgStyle,
            }}
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = "/image-not-found.png";
            }}
            priority
            fetchPriority="high"
          />
        </Link>
      </div>

      {/* <div className={`card-body pt-4 ${bodyClassName}`}> */}
      <div
        className={`card-body ${compact ? "p-0 ps-2" : "pt-4"} ${bodyClassName}`}
      >
        <div className={`mb-1 author-date-card  ${metaClassName}`}>
          <span className={`gh-card-authors ${authorClassName}`}>
            By <Link href={`/${authorSlug}`} className={`${authorSlugClassName}`}>
              {authorName}
            </Link>
          </span>
          <span className={`dot-separator ${dotSeparatoClassName}`}>•</span>{" "}
          {/* ✅ add • here */}
          <span className={` gh-card-authors ${timeClassName}`}>
            {formattedDate}
          </span>
        </div>
        <Link
          href={cardLink || "location not found"}
          className="text-decoration-none"
        >
          <h5 className={`fw-bold my-2  ${titleClassName}`}>{titleText}</h5>
        </Link>

        {/* <div className="d-flex gap-2 py-3 flex-wrap mt-2"> */}
        <div
          className={`d-flex gap-2 flex-wrap mt-2 ${compact ? "py-0" : "py-3"}`}
        >
          {category_name && (
            <Link href={ensureAbsolute(category_slug)}>
              <span
                className="badge gh-tag"
                style={
                  {
                    "--accent": category_color ?? "#00897B",
                    background: category_color
                      ? `color-mix(in srgb, ${category_color} 80%, transparent)`
                      : "#00897B",
                    color: "#ffffff",
                  } as React.CSSProperties
                }
              >
                {category_name}
              </span>
            </Link>
          )}
          {sub_category_name && (
            <Link href={ensureAbsolute(sub_category_slug)}>
              <span
                className="badge gh-tag "
                // style={{ backgroundColor: sub_category_color }}
                style={
                  {
                    "--accent": category_color ?? "#00897B",
                    background: category_color
                      ? `color-mix(in srgb, ${category_color} 80%, transparent)`
                      : "#00897B",
                    color: "#ffffff",
                  } as React.CSSProperties
                }
              >
                {sub_category_name}
              </span>
            </Link>
          )}

          {links?.map((link, index) => (
            <span
              key={index}
              className="badge rounded-pill bg-primary-subtle text-primary"
            >
              {link}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
